module.exports = __webpack_public_path__ + "static/media/cv.da670230.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/cv.png
// module id = 1826
// module chunks = 0